module.exports = __webpack_public_path__ + "img/1088252561.546dc4a9.png";